import { Subscription } from "../../types/plans";

interface PaymentSuccessProps {
  selectedPlan: Subscription;
}

export function PaymentSuccess({ selectedPlan }: PaymentSuccessProps) {
  const handleReturnDashboard = () => {
    const dashboardUrl = "https://dash.coralytics.com/login";
    window.location.href = dashboardUrl;
  };

  return (
    <div
      className=" d-flex align-items-center justify-content-center"
      style={{}}
    >
      <div className="card shadow-lg border-0" style={{}}>
        <div className="card-body p-5 text-center">
          <div className="mb-4">
            <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-success bg-opacity-10 p-3">
              <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-success p-2">
                <svg
                  className="text-white"
                  width="20"
                  height="20"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
          <h2 className="h4 fw-bold text-dark mb-3">Payment Successful!</h2>
          <p className="text-muted mb-4">
            Your subscription to {selectedPlan.name} has been activated.
          </p>
          <button
            onClick={handleReturnDashboard}
            className="btn btn-success btn-lg px-4 py-2"
            style={{
              background: "linear-gradient(135deg, #198754 0%, #20c997 100%)",
              border: "none",
            }}
          >
            Proceed to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
